export default "__VITE_ASSET__0dcf29c1__"